import React from 'react'
import { Routes, Route } from 'react-router-dom'

import AttachmentsIndex from './attachments_index.jsx'
import AttachmentsNew from './attachments_new.jsx'

let AttachmentsRouter = () => (
  <Routes>
    <Route path=""          element={ <AttachmentsIndex /> } />
    <Route path="new"      element={ <AttachmentsNew /> } />
  </Routes>
)

export default AttachmentsRouter
